import React from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import {useStateValue} from './StateProvider'
import {getTotalCheckout} from './reducer'
import { useHistory } from 'react-router-dom';

function Subtotal() {

    const history = useHistory();
    const [state, dispatcher] = useStateValue();

    return (
        <div className='subtotal'>
            <CurrencyFormat
            value={getTotalCheckout(state.cart)}
            decimalScale={2}
                displayType={'text'}    
                thousandSeparator={true}
                prefix={'$'}
                renderText={value=> 
                        
                    <>
                        <p>
                            Subtotal ({state.cart.length} items): <strong>{value}</strong>
                        </p>
                        <small className='subtotal__gift'>
                            <input type='checkbox'/> This order contains a gift
                        </small>
                    </>
                    
                    
                }
                /> 
            <button onClick={e=> history.push('/payment')}>Proceed to Checkout</button>
        </div>
    );

}

export default Subtotal;